import { render, staticRenderFns } from "./DeviceAdd.vue?vue&type=template&id=53c95170"
import script from "./DeviceAdd.vue?vue&type=script&lang=js"
export * from "./DeviceAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../4rahgit/GPS-Tracking-Client-Panel/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports